module.exports = __webpack_public_path__ + "media/images/pc/page_common/map-22a606954533117f2320049948d6ec6d.svg";